import { useEffect } from 'react';
import { useRouter } from 'next/router';

const LEGACY_HASH_REDIRECTS: { match: (hash: string) => boolean; destination: string }[] = [
  { match: (hash) => hash.includes('commandes|sales'), destination: '/my-account/orders-sales?section=2' },
  { match: (hash) => hash.includes('commandes|orders'), destination: '/my-account/orders-sales?section=1' },
  { match: (hash) => hash.includes('commandes'), destination: '/my-account/orders-sales' },
  { match: (hash) => hash === 'alerts' || hash === 'alertes', destination: '/alerts' },
  { match: (hash) => hash === 'produits' || hash === 'produits|vente', destination: '/listings' },
];

export const useLegacyHashRedirect = () => {
  const router = useRouter();

  useEffect(() => {
    const rawHash = window.location.hash;
    if (!rawHash) {
      return;
    }

    const hash = rawHash.slice(1).split('?')[0];
    const redirect = LEGACY_HASH_REDIRECTS.find(({ match }) => match(hash));

    if (redirect) {
      router.replace(redirect.destination);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
